import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { maskPublishingCredentialRequest } from './utils/publishingCredentialPrivacy';
import WalletContextProvider from "./WalletProvider";
import { PostHogProvider} from 'posthog-js/react'

const options = {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    session_recording: { maskCapturedNetworkRequestFn: maskPublishingCredentialRequest },
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <PostHogProvider
            apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
            options={options}
        >

        <BrowserRouter>
            <WalletContextProvider>
                <App />                    {/*     is guaranteed to be inside WalletProvider */}
            </WalletContextProvider>
        </BrowserRouter>
        </PostHogProvider>
    </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        if (process.env.NODE_ENV === 'production') {
            navigator.serviceWorker
                .register('/sw.js')
                .then(reg => {
                    console.log('Service worker registered', reg);
                })
                .catch(err => {
                    console.error('Service worker registration failed', err);
                });
            return;
        }

        navigator.serviceWorker
            .getRegistrations()
            .then(registrations => {
                registrations.forEach(registration => registration.unregister());
            })
            .catch(err => {
                console.error('Service worker cleanup failed', err);
            });

        if ('caches' in window) {
            caches
                .keys()
                .then(keys => Promise.all(
                    keys
                        .filter(key => key.startsWith('MuultiSpace-'))
                        .map(key => caches.delete(key))
                ))
                .catch(err => {
                    console.error('Service worker cache cleanup failed', err);
                });
        }
    });
}


